// +/- 20% jitter so many open tabs don't all refresh in the same instant
const JITTER_RATIO = 0.2

function withJitter(intervalMs) {
  const jitter = intervalMs * JITTER_RATIO
  return Math.round(intervalMs + (Math.random() * 2 - 1) * jitter)
}

export default {
  data() {
    return {
      interval: null,
      pollLastRun: 0,
      onVisibilityChange: null
    }
  },
  beforeDestroy() {
    this.stopPolling()
  },
  methods: {
    // Runs `callback` on an interval, skipping ticks while the tab is hidden, and
    // catching up once when the tab becomes visible again if a refresh was missed.
    startPolling(callback, interval) {
      this.pollLastRun = Date.now()

      this.interval = setInterval(() => {
        if (document.visibilityState !== 'visible') return
        this.pollLastRun = Date.now()
        callback()
      }, withJitter(interval))

      this.onVisibilityChange = () => {
        if (document.visibilityState !== 'visible') return
        if (Date.now() - this.pollLastRun < interval) return
        this.pollLastRun = Date.now()
        callback()
      }

      document.addEventListener('visibilitychange', this.onVisibilityChange)
    },
    stopPolling() {
      if (this.interval) {
        clearInterval(this.interval)
        this.interval = null
      }

      if (this.onVisibilityChange) {
        document.removeEventListener('visibilitychange', this.onVisibilityChange)
        this.onVisibilityChange = null
      }
    }
  }
}
